import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { searchTranslationRef } from '@backstage/plugin-search';

export const searchTranslations = createTranslationResource({
  ref: searchTranslationRef,
  translations: {
    'pt-BR': () => import('./pt-BR'),
  },
});
